<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("PURCHASES_PAYMENTS.ADD_PURCHASES_PAYMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <purchasesPayment-form
              :loading="loading"
              :purchasesPaymentData="purchasesPayment"
              :formErrors="formErrors"
              @purchasesPaymentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesPayment from "./defaultPurchasesPayment";
import PurchasesPaymentForm from "./partials/PurchasesPaymentForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PurchasesPaymentForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      purchasesPayment: cloneDeep(defaultPurchasesPayment),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List PurchasesPayments" });
    },

    viewPurchasesPayment(purchasesPayment) {
      this.alertLeave = false;
      this.$router.push({
        name: "View PurchasesPayment",
        params: { id: purchasesPayment.id },
      });
    },

    async handleSubmit(purchasesPaymentData) {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "purchasesPayments/add",
          purchasesPaymentData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_PAYMENTS.PURCHASES_PAYMENT_ADDED"),
        });
        const purchasesPayment = await this.$store.getters[
          "purchasesPayments/purchasesPayment"
        ];
        this.viewPurchasesPayment(purchasesPayment);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
